/** @jsxImportSource @emotion/react */
import React from "react";
import { colors } from "./colors";
import { css, SerializedStyles } from "@emotion/react";

interface VerticalDividerProps extends React.HTMLAttributes<HTMLDivElement> {
  backgroundColor?: string;
  height?: string;
  width?: string;
  additionalStyles?: SerializedStyles;
}

export const VerticalDivider = ({
  backgroundColor,
  height,
  additionalStyles,
  width,
  ...rest
}: VerticalDividerProps) => {
  const dividerStyle = css`
    display: flex;
    width: ${width || "1px"};
    min-width: ${width || "1px"};
    height: ${height || "16px"};
    background-color: ${backgroundColor || colors.ctaInactive};
    ${additionalStyles}
  `;

  return <div css={dividerStyle} {...rest} />;
};
